import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const NiosEditClass = () => {
  const [niosClassEdit, setNiosClassEdit] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/niosClass/${id}`)
      .then((response) => {
        setNiosClassEdit(response.data?.className);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  let handleEditSave = () => {
    axios
      .put(
        `${API_BASE_URL}/admin/niosClass/${id}`,
        { className: niosClassEdit },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((resp) => {
        // window.location.reload("/school-all-class");
        alert("Data Updated Successfully");
        navigate("/nios-all-class");
      })
      .catch((err) => {
        alert("Error", err);
      });
    navigate("/nios-all-class");
  };

  const handleAddNewClass = () => {
    navigate("/nios-add-class");
  };

  const handleViewAllClasses = () => {
    navigate("/nios-all-class");
  };

  const handleEdit = (e) => {
    setNiosClassEdit(e.target.value);
  };
  return (
    <div id="add-department-inner-wrapper">
      <div className="superheader">
        <div className="departmetHeaderdiv">
          <h5>Nios Edit Class</h5>
          <div className="departmentdiv2">
            <button className="handlenewclass" onClick={handleAddNewClass}>
              + Add New Class
            </button>
            <button className="allclasses" onClick={handleViewAllClasses}>
              All Classes
            </button>
          </div>
        </div>

        <div className="form-school-container">
          <h4 className="department-detail">Nios Class Details</h4>
          <form onSubmit={handleEditSave} className="department-detail-form">
            <div className="input-group">
              <div style={{ paddingBottom: "10px" }}>
                <label className="label"> Class Name</label>
              </div>
              <input
                style={{
                  marginLeft: "1px",
                  borderBottomLeftRadius: "5px",
                  borderTopLeftRadius: "5px",
                }}
                type="text"
                value={niosClassEdit}
                onChange={handleEdit}
                placeholder="Enter Class Name"
                required
              />
            </div>
            <div className="form-school-btns">
              <button className="btn-s" type="save">
                Save
              </button>
              <button className="btn-c" type="cancel">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NiosEditClass;
